export default {"src":"/_next/static/media/pasc.99f63e02.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};